export default function dropletName() {
  return {
    _id: false,
    type: 'droplet.groupList',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    visible: 6,
    showImage: true,
    loadMoreText: 'Load More',
    isShared: false,
    siteType: null,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/group-list/droplet.schema.js